import Post from "../components/Post";
import { useEffect, useState } from "react";
import axios from "axios";
import { Loader } from "lucide-react";
import './loader.css';

const Posts = () => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchPosts = async () => {
    const response = await axios.get("https://skblogs-backend.netlify.app/api/posts/");
    setPosts(response.data);
    setIsLoading(false);
  };
  useEffect(() => {
    fetchPosts();
  }, []);
  return (
    <main>
      <div className="container mt-4">
        <div className="row">
          <div className="col-12">
            <h1 className="mb-4" style={{color: "#219ebc"}}>Latest Posts</h1>
            {posts.length > 0 ? (
                posts.map((post,i) => <Post key={i} post={post} value={300} />)
              ) : (
                isLoading ? <div className="d-flex align-items-center justify-content-center" style={{ height: "95vh" }}>
                  <Loader className="loader" />
                </div> : <h3 className="mb-3">No Posts Available</h3>
              )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default Posts;
